import styled from 'styled-components';

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
  .p-inputtext {
    width: 100%;
  }

  small.p-error {
    color: red;
    font-size: 0.75rem;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const FormTitle = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.8rem;
`;
